module.exports = __webpack_public_path__ + "static/media/amex.e2e8f231.svg";